<div class="info-request-workspace-page page">
  <div class="top-content">
    <app-tabs [tabs]="workspaceTabs" [activeTab]="activeSection" (tabChange)="setActiveSection($event)" />
    <div class="actions">
      @if (activeSection) {
        <button
          class="primary"
          [policyType]="POLICY_TYPE_SERVICE"
          [claimType]="CLAIM_TYPES['create']"
          (click)="createInfoRequest()"
          appPermission>
          {{ 'pages.infoRequestWorkspace.createRequest' | translate }}
        </button>
        <button
          class="secondary download-excel"
          [disabled]="isExcelDownloading"
          [ngClass]="{ downloading: isExcelDownloading }"
          [policyType]="POLICY_TYPE_SERVICE"
          [claimType]="CLAIM_TYPES['read']"
          (click)="getExcelFile()"
          appPermission>
          @if (!isExcelDownloading) {
            <img class="icon" src="assets/images/download-excel.svg" alt="download-excel.svg" />
            {{ 'pages.user.saveExcel' | translate }}
          } @else {
            <div class="spinner-wrapper">
              <div class="spinner"></div>
            </div>
          }
        </button>
      }
    </div>
  </div>
  <div class="content">
    @if (activeSection === 'tasks') {
      <app-table
        #tasksTable
        [columns]="myTaskColumns"
        [endpoint]="taskApiPath"
        [responseKey]="'page'"
        [flatTopBorder]="true"
        [linkRow]="false"
        [sortBy]="'ExecutionDate'"
        [sortDirection]="'asc'"
        [showTooltipText]="true"
        [tableTooltipText]="'infoRequestWorkspaceTasksTable'"
        [defaultFilters]="tasksDefaultFilters"
        [topFilterOptions]="myTaskStatusOptions"
        [topFilterTranslatePrefix]="'pages.infoRequestWorkspace.taskStatus.'"
        [topFilterCounts]="tasksStatusCounts"
        [topFilterDefaultSelected]="['Assigned', 'Accepted']"
        [topFilterParamName]="'statuses'"
        (responseLoaded)="onTasksResponseLoaded($event)"
        (customActionClicked)="onTaskAction($event)"
        [policyType]="POLICY_TYPE_MY_WORKSPACE"
        [claimType]="CLAIM_TYPES['workspaceMyInformationRequests']"
        appPermission />
    } @else if (activeSection === 'requests') {
      <app-table
        #requestsTable
        [columns]="myRequestColumns"
        [endpoint]="apiPath"
        [responseKey]="'page'"
        [sortBy]="'SubmittedOn'"
        [sortDirection]="'desc'"
        [getViewPathFn]="getInfoRequestViewPath"
        [showTooltipText]="true"
        [tableTooltipText]="'infoRequestWorkspaceRequestsTable'"
        [defaultFilters]="requestsDefaultFilters"
        [topFilterOptions]="myRequestStatusOptions"
        [topFilterTranslatePrefix]="'pages.service.infoRequest.backofficeStatus.'"
        [topFilterCounts]="requestsStatusCounts"
        [topFilterParamName]="'backofficeStatuses'"
        (responseLoaded)="onRequestsResponseLoaded($event)"
        [policyType]="POLICY_TYPE_MY_WORKSPACE"
        [claimType]="CLAIM_TYPES['workspaceMyInformationRequests']"
        appPermission />
    } @else if (activeSection === 'structuralUnitRequests') {
      <app-table
        #structuralUnitRequestsTable
        [columns]="departmentRequestColumns"
        [endpoint]="apiPath"
        [responseKey]="'page'"
        [sortBy]="'SubmittedOn'"
        [sortDirection]="'desc'"
        [getViewPathFn]="getInfoRequestViewPath"
        [showTooltipText]="true"
        [tableTooltipText]="'infoRequestWorkspaceStructuralUnitTable'"
        [defaultFilters]="structuralUnitDefaultFilters"
        [showEmpty]="!hasGlobalInformationRequestScope && structuralUnitIds.length === 0"
        [topFilterOptions]="departmentStatusOptions"
        [topFilterTranslatePrefix]="'pages.service.infoRequest.backofficeStatus.'"
        [topFilterCounts]="structuralUnitStatusCounts"
        [topFilterParamName]="'backofficeStatuses'"
        (responseLoaded)="onStructuralUnitResponseLoaded($event)"
        [policyType]="POLICY_TYPE_MY_WORKSPACE"
        [claimType]="CLAIM_TYPES['workspaceStructuralUnitInformationRequests']"
        appPermission />
    } @else if (activeSection === 'allRequests') {
      <app-table
        #allRequestsTable
        [columns]="allRequestsColumns"
        [endpoint]="apiPath"
        [responseKey]="'page'"
        [sortBy]="'SubmittedOn'"
        [sortDirection]="'desc'"
        [getViewPathFn]="getInfoRequestViewPath"
        [showTooltipText]="true"
        [tableTooltipText]="'infoRequestWorkspaceAllRequestsTable'"
        [defaultFilters]="allRequestsDefaultFilters"
        [topFilterOptions]="allStatusOptions"
        [topFilterTranslatePrefix]="'pages.service.infoRequest.backofficeStatus.'"
        [topFilterCounts]="allRequestsStatusCounts"
        [topFilterParamName]="'backofficeStatuses'"
        (responseLoaded)="onAllRequestsResponseLoaded($event)"
        [policyType]="POLICY_TYPE_MY_WORKSPACE"
        [claimType]="CLAIM_TYPES['workspaceAllInformationRequests']"
        appPermission />
    } @else if (activeSection === 'allTasks') {
      <app-table
        #allTasksTable
        [columns]="allTaskColumns"
        [endpoint]="taskApiPath"
        [responseKey]="'page'"
        [flatTopBorder]="true"
        [sortBy]="'Code'"
        [sortDirection]="'desc'"
        [getViewPathFn]="getTaskViewPath"
        [showTooltipText]="true"
        [tableTooltipText]="'infoRequestWorkspaceAllTasksTable'"
        [defaultFilters]="allTasksDefaultFilters"
        [initialColumnFilters]="allTasksInitialColumnFilters"
        [topFilterOptions]="allTaskStatusOptions"
        [topFilterTranslatePrefix]="'pages.infoRequestWorkspace.taskStatus.'"
        [topFilterCounts]="allTasksStatusCounts"
        [topFilterParamName]="'statuses'"
        (responseLoaded)="onAllTasksResponseLoaded($event)"
        [policyType]="POLICY_TYPE_MY_WORKSPACE"
        [claimType]="CLAIM_TYPES['workspaceAllInformationRequests']"
        appPermission />
    }
  </div>

  <app-confirm-modal
    [isOpen]="isCompleteTaskConfirmOpen"
    title="completeTaskConfirmTitle"
    bodyText="completeTaskConfirmBody"
    confirmText="completeTaskConfirm"
    denyText="completeTaskDeny"
    (confirm)="confirmCompleteTask()"
    (cancel)="cancelCompleteTask()" />

  <app-confirm-modal
    [isOpen]="isCancelTaskConfirmOpen"
    title="cancelTaskConfirmTitle"
    bodyText="cancelTaskConfirmBody"
    confirmText="cancelTaskConfirm"
    denyText="cancelTaskDeny"
    (confirm)="confirmCancelTask()"
    (cancel)="cancelCancelTask()" />
</div>
